import * as React from 'react'

import type { Transition } from 'framer-motion'
import { motion } from 'framer-motion'

import { observer } from 'mobx-react'

import Portal from 'modules/core/components/Portal'

import * as styles from './Detail.vanilla.css'

const getTransition = (duration: number): Transition => ({
  duration,
  cubicBeizer: [0.175, 0.885, 0.32, 1.275],
})

interface DetailPortalProps {
  onClose: () => void
}

const DetailPortal = ({ children, onClose }: React.PropsWithChildren<DetailPortalProps>) => {
  return (
    <Portal onClose={onClose}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={getTransition(0.6)}
        className={styles.overlay}
        aria-modal="true"
      >
        {children}
      </motion.div>
    </Portal>
  )
}

export default observer(DetailPortal)
